var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    viewBox: "0 0 3455 1055",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,113.247C0,86.893 14.793,80.677 39.655,80.677L72.101,80.677C111.385,80.677 116.481,89.131 116.233,114.614L88.635,114.614L88.635,112.129C88.635,105.664 83.911,103.8 75.707,103.8L45.623,103.8C31.078,103.8 28.343,110.636 28.343,121.825L28.343,131.521C28.343,144.574 31.078,149.546 44.131,149.546L73.593,149.546C86.024,149.546 89.754,148.304 89.754,137.115L117.352,137.115L117.352,145.569C117.352,160.736 111.882,172.669 84.16,172.669L39.655,172.669C14.793,172.669 0,166.453 0,140.099L0,113.247Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.371,131.521C160.371,144.574 163.106,149.546 176.159,149.546L211.464,149.546C224.517,149.546 227.252,144.574 227.252,131.521L227.252,121.825C227.252,110.636 224.517,103.8 209.972,103.8L177.651,103.8C163.106,103.8 160.371,110.636 160.371,121.825L160.371,131.521ZM132.028,113.247C132.028,86.893 146.821,80.677 171.684,80.677L215.939,80.677C240.802,80.677 255.595,86.893 255.595,113.247L255.595,140.099C255.595,166.453 240.802,172.669 215.939,172.669L171.684,172.669C146.821,172.669 132.028,166.453 132.028,140.099L132.028,113.247Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.78,
    y: 81.672,
    width: 27.597,
    height: 90.003,
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.654,81.672L630.417,81.672L682.255,147.06L682.504,147.06L682.504,81.672L710.102,81.672L710.102,171.675L667.338,171.675L615.5,106.286L615.25,106.286L615.25,171.675L587.654,171.675L587.654,81.672Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.167,81.672L827.336,81.672L827.336,104.048L788.551,104.048L788.551,171.675L760.954,171.675L760.954,104.048L722.167,104.048L722.167,81.672Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.953,233.58L505.953,236.251C505.953,242.816 508.777,243.274 518.927,243.274C528.927,243.274 530.3,241.442 530.3,234.801C530.3,226.635 525.951,227.703 517.401,227.245C505.038,226.482 495.268,226.94 495.268,210.301C495.268,194.579 505.19,194.12 518.927,194.12C530.606,194.12 540.146,194.502 540.146,209.538L540.146,211.369L529.156,211.369L529.156,209.538C529.156,203.356 526.637,203.127 518.927,203.127C508.014,203.127 506.259,204.196 506.259,210.301C506.259,217.323 507.708,217.552 518.852,218.239C536.483,219.308 541.292,220.224 541.292,234.801C541.292,250.906 533.66,252.28 518.927,252.28C506.259,252.28 494.962,252.661 494.962,236.251L494.962,233.58L505.953,233.58Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.681,231.901C555.681,242.586 556.369,244.952 564.917,244.952C573.464,244.952 574.152,242.586 574.152,231.901C574.152,221.063 573.464,218.62 564.917,218.62C556.369,218.62 555.681,221.063 555.681,231.901ZM583.769,231.824C583.769,247.319 581.631,252.28 564.917,252.28C548.201,252.28 546.064,247.319 546.064,231.824C546.064,216.254 548.201,211.293 564.917,211.293C581.631,211.293 583.769,216.254 583.769,231.824Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.484,219.078L602.714,219.078L602.714,251.822L593.097,251.822L593.097,219.078L587.449,219.078L587.449,211.751L593.097,211.751L593.097,208.24C593.097,198.623 595.387,194.579 605.919,194.579L612.179,194.579L612.179,201.906L609.279,201.906C602.714,201.677 602.714,204.348 602.714,209.309L602.714,211.751L612.484,211.751L612.484,219.078Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.712,211.751L623.75,211.751L623.75,202.669L633.367,202.669L633.367,211.751L648.708,211.751L648.708,219.078L633.367,219.078L633.367,239.61C633.444,243.274 633.444,244.952 637.489,244.952C642.908,244.952 642.297,240.678 642.297,236.481L650.769,236.481C650.921,248.616 647.869,252.28 637.489,252.28C626.957,252.28 623.75,249.837 623.75,239.686L623.75,219.078L618.712,219.078L618.712,211.751Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.473,251.822L689.734,251.822L682.56,219.613L682.332,219.613L675.233,251.822L661.265,251.822L652.183,211.751L661.647,211.751L668.44,245.258L668.669,245.258L676.455,211.751L688.437,211.751L696.146,245.258L696.451,245.258L703.32,211.751L712.632,211.751L703.473,251.822Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.091,239.533C723.091,245.182 725.38,245.716 731.869,245.716C736.982,245.716 740.722,245.258 740.722,239.533C740.722,233.962 736.601,233.809 731.869,233.809C726.984,233.809 723.091,233.809 723.091,239.533ZM741.104,246.784L740.875,246.784C738.966,252.127 733.089,252.28 728.434,252.28C719.351,252.28 713.474,250.371 713.474,239.533C713.474,229.916 718.511,227.245 728.434,227.245C733.319,227.245 738.126,227.322 740.417,231.824L740.722,231.824L740.722,226.635C740.722,220.147 740.188,217.858 732.173,217.858C727.976,217.858 724.618,218.239 724.618,223.429L715.001,223.429C715.001,211.751 723.015,211.293 732.173,211.293C744.996,211.293 750.339,213.278 750.339,226.711L750.339,251.822L740.722,251.822L741.104,246.784Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.255,211.751L766.026,217.018L766.408,217.018C768.316,212.591 772.437,211.293 777.093,211.293C785.565,211.293 787.626,216.331 787.626,223.887L787.626,227.093L778.62,227.093L778.62,225.031C778.62,220.987 778.238,218.62 773.735,218.62C768.01,218.62 766.332,221.903 766.484,227.093L766.484,251.822L756.867,251.822L756.867,211.751L766.255,211.751Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.378,227.474C819.378,219.232 818.158,218.62 810.296,218.62C801.976,218.62 801.443,220.376 801.443,227.474L819.378,227.474ZM828.996,239.075C828.996,251.669 821.745,252.28 810.296,252.28C794.955,252.28 791.826,247.395 791.826,231.901C791.826,217.552 794.115,211.293 810.296,211.293C826.782,211.293 828.996,216.102 828.996,233.58L801.443,233.58C801.443,242.205 801.671,244.952 810.296,244.952C815.638,244.952 819.378,245.029 819.378,239.075L828.996,239.075Z",
    style: {
      fill: "rgb(19,126,176)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.5,0.346L376.032,35.133L385.67,37.39L327.196,148.552L292.016,81.672L261.808,81.672L310.166,171.675L344.228,171.675L409.633,49.944L416.986,56.435L420.5,0.346Z",
    style: {
      fill: "rgb(156,204,81)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.015,253L463.484,218.214L453.845,215.956L512.32,104.794L547.5,171.675L577.708,171.675L529.35,81.672L495.289,81.672L429.882,203.404L422.53,196.911L419.015,253Z",
    style: {
      fill: "rgb(156,204,81)",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsLogo);
export default __webpack_public_path__ + "static/media/cs-logo.4b10ec6d5ff2918c9cdc9e3677cb8ccb.svg";
export { ForwardRef as ReactComponent };